import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useNotifications } from '../hooks/useNotifications';

/**
 * Invisible component that bridges SignalR notifications → React Query cache invalidation.
 * Must be rendered inside QueryClientProvider.
 * When an appointment-related notification arrives via SignalR, invalidates the
 * ['appointments'] query key so all consumers (AppointmentsPage etc.) refetch automatically.
 */
export default function QueryInvalidator() {
  const queryClient = useQueryClient();

  const handleNotification = useCallback((notification) => {
    const type = notification?.type ?? notification?.notificationType;
    if (!type) return;
    if (type.startsWith('appointment.')) {
      queryClient.invalidateQueries({ queryKey: ['appointments'] });
    }
    // Saldo/crédito mudou (compra confirmada ou alerta de saldo baixo/zerado) →
    // atualiza o snapshot de entitlements p/ o MeterBadge e o banner de saldo refletirem (5.5).
    if (type.startsWith('billing.credits.') || type === 'billing.order.paid') {
      queryClient.invalidateQueries({ queryKey: ['entitlements'] });
    }
  }, [queryClient]);

  useNotifications(handleNotification);

  return null;
}
